/*
  MARTIN MARTIN — Custom section "mm-boutique-edito" (update-safe)
  Galerie légère : défilement natif (scroll-snap), flèches et pagination
  (points, segments, compteur, barre de progression). Met aussi en pause les
  vidéos hors écran. Aucune dépendance et aucun fichier core Sahara modifié.
*/
if (!customElements.get('mm-boutique-gallery')) {
  class MmBoutiqueGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mm-boutique__track');
      if (!this.track) return;
      this.slides = Array.from(this.track.querySelectorAll('.mm-boutique__slide'));
      this.items = Array.from(this.querySelectorAll('[data-pager-item]'));
      this.counters = Array.from(this.querySelectorAll('[data-pager-current]'));
      this.bars = Array.from(this.querySelectorAll('[data-pager-bar]'));

      this.querySelectorAll('.mm-boutique__arrow--prev').forEach((button) =>
        button.addEventListener('click', () => this.goTo(this.current() - 1))
      );
      this.querySelectorAll('.mm-boutique__arrow--next').forEach((button) =>
        button.addEventListener('click', () => this.goTo(this.current() + 1))
      );
      this.items.forEach((item) =>
        item.addEventListener('click', () => this.goTo(Number(item.dataset.pagerItem)))
      );

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.observeVideos();
      this.update();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.videoObserver?.disconnect();
    }

    current() {
      const left = this.track.scrollLeft;
      let closest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const d = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
        if (d < distance) {
          distance = d;
          closest = index;
        }
      });
      return closest;
    }

    goTo(index) {
      const count = this.slides.length;
      if (count < 2) return;
      const target = this.slides[(index + count) % count];
      this.track.scrollTo({
        left: target.offsetLeft - this.track.offsetLeft,
        behavior: 'smooth'
      });
    }

    onScroll() {
      window.cancelAnimationFrame(this.frame);
      this.frame = window.requestAnimationFrame(() => this.update());
    }

    update() {
      const count = this.slides.length;
      if (count < 2) return;
      const active = this.current();

      this.items.forEach((item) =>
        item.setAttribute(
          'aria-current',
          Number(item.dataset.pagerItem) === active ? 'true' : 'false'
        )
      );

      const label = String(active + 1).padStart(2, '0');
      this.counters.forEach((counter) => {
        counter.textContent = label;
      });

      const max = this.track.scrollWidth - this.track.clientWidth;
      const ratio = max > 0 ? Math.min(Math.max(this.track.scrollLeft / max, 0), 1) : 0;
      this.bars.forEach((bar) => {
        bar.style.transform = `translateX(${ratio * (count - 1) * 100}%)`;
      });
    }

    observeVideos() {
      const videos = this.querySelectorAll('video[autoplay]');
      if (!videos.length || !('IntersectionObserver' in window)) return;
      this.videoObserver = new IntersectionObserver(
        (entries) =>
          entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.play?.().catch(() => {});
            else entry.target.pause?.();
          }),
        { threshold: 0.25 }
      );
      videos.forEach((video) => this.videoObserver.observe(video));
    }
  }

  customElements.define('mm-boutique-gallery', MmBoutiqueGallery);
}
